import { Component, Input } from "@angular/core";

@Component({
  selector: "gem-help-icon",
  templateUrl: "./gem-help-icon.component.html",
  styleUrls: ["./gem-help-icon.component.scss"],
  standalone: false,
})
export class GemHelpIconComponent {
  @Input() tooltip = "";
}
